import { render } from "./xfsMain.vue?vue&type=template&id=86ce0944&scoped=true"
import script from "./xfsMain.vue?vue&type=script&lang=js"
export * from "./xfsMain.vue?vue&type=script&lang=js"

import "./xfsMain.vue?vue&type=style&index=0&id=86ce0944&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ce0944"]])

export default __exports__